import { Navigate, useLocation, useParams } from 'react-router-dom'

import UploadSingleSpot from '../ViewUpload/UploadSingleSpot'
import DashboardAgamiDetail from '../views/DashboardAgamiDetail'
import { useAgamiRoutes } from '../hooks/useAgamiRoutes'

const redirectTarget = (pathname: string, search: string, hash: string) => ({
  pathname,
  search,
  hash,
})

export const LegacyAgamiUploadRoute: React.FC = () => {
  const location = useLocation()
  const { newAgamiPath } = useAgamiRoutes()
  const pathname = newAgamiPath()

  if (pathname === '/upload/spot') return <UploadSingleSpot />

  return (
    <Navigate to={redirectTarget(pathname, location.search, location.hash)} state={location.state} replace />
  )
}

export const LegacyAgamiDetailRoute: React.FC = () => {
  const { id = '' } = useParams()
  const location = useLocation()
  const { agamiFormPath } = useAgamiRoutes()
  const pathname = agamiFormPath(id)

  if (pathname === `/spot/${id}`) return <DashboardAgamiDetail />

  return (
    <Navigate to={redirectTarget(pathname, location.search, location.hash)} state={location.state} replace />
  )
}
